import React from 'react'
import dynamic from 'next/dynamic'

import { isFastCommentsEnabled } from '@lib/utils/feature-flag'

const CodingalComments = dynamic(
  () => import('@components/common/codingal-comments'),
  { ssr: false }
)

const FastComments = dynamic(() => import('@components/common/fast-comments'), {
  ssr: false,
})

type ProductCommentsProps = {
  pageId: string
  loginCallback: () => void
  title?: string
}

const ProductComments = ({
  pageId,
  loginCallback,
  title = 'Comments',
}: ProductCommentsProps) => {
  if (isFastCommentsEnabled()) {
    return <FastComments uniqueUrl={pageId} loginCallback={loginCallback} />
  }

  return (
    <CodingalComments
      pageId={pageId}
      title={title}
      loginCallback={loginCallback}
    />
  )
}

export default ProductComments
